import loadable from '@loadable/component';
import { PageLoading } from "@tawn33y/gigsflow-core";

const About = loadable(() => import('@tawn33y/gigsflow-core/dist/pages/About/About'), {
  resolveComponent: (components) => components.About,
  fallback: (
    <PageLoading
      title="About"
      description="Learn about Gigsflow and our mission"
      url="https://gisflow.com/about"
    />
  ),
});

export default function AboutPage() {
  return <About />
}
